import { formatCurrencyAmount } from '../../../../common/helpers/currency';

export const CONFIRM_MODAL_HEADING_NO_PAYMENT = 'Ready to submit application?';
export const CONFIRM_MODAL_HEADING_PAYMENT_REQUIRED = 'Let’s reserve your funds!';
export const CONFIRM_MODAL_SUB_HEADING_NO_PAYMENT =
  'Please be advised that you cannot make any changes after submitting your application';

export const CONFIRM_MODAL_SUB_HEADING_PAYMENT_REQUIRED_AMOUNT_PREFIX =
  'Your application is subject to FICA approval, we will reserve an amount of R ';
export const CONFIRM_MODAL_SUB_HEADING_PAYMENT_REQUIRED_AMOUNT_SUFFIX =
  '. If the FICA application is declined, the once off amount will be reversed back to your account.';

export const CONFIRM_MODAL_PRIMARY_BUTTON_TEXT_NO_PAYMENT = 'Submit';
export const CONFIRM_MODAL_PRIMARY_BUTTON_TEXT_PAYMENT_REQUIRED = 'Reserve funds';

export const getConfirmModalSubheadingPaymentRequired = (paymentAmountCents: number) => {
  const paymentAmountFormatted = formatCurrencyAmount(paymentAmountCents);
  return `${CONFIRM_MODAL_SUB_HEADING_PAYMENT_REQUIRED_AMOUNT_PREFIX}${paymentAmountFormatted}${CONFIRM_MODAL_SUB_HEADING_PAYMENT_REQUIRED_AMOUNT_SUFFIX}`;
};
